import { Box, Skeleton } from '@nimbus-ds/components';
import { DataList } from '@nimbus-ds/patterns';

export function TransferListRowSkeleton() {
  return (
    <DataList.Row backgroundColor="transparent">
      <Box display="grid" gridTemplateColumns="1fr 1fr" gap="3">
        <Skeleton width="48px" height="16px" />
        <Box display="flex" justifyContent="flex-end">
          <Skeleton width="80px" height="16px" />
        </Box>
        <Skeleton width="120px" height="16px" />
        <div />
        <Skeleton width="104px" height="16px" />
      </Box>
    </DataList.Row>
  );
}

export default TransferListRowSkeleton;
